export const HIVEMIND_DEFAULT = 'default';
export const HIVEMIND_INELIGIBLE = 'ineligible';
export const HIVEMIND_ON = 'on';
export const HIVEMIND_OFF = 'off';
export const HIVEMIND_VARIANT = 'variant';
